let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4pftF")).then(() => parcelRequire('4dSUs'));